import React from "react";
import { Dialog } from "radix-ui";
import { RadixDialogue } from "./RadixDialogue";
import "../ui.css";
import { useDataUiTheme } from "../utility/getDataUiTheme";
export var RadixFlyOut = function (_a) {
    var open = _a.open, onOpenChange = _a.onOpenChange, title = _a.title, description = _a.description, children = _a.children, _b = _a.closeLabel, closeLabel = _b === void 0 ? "Close panel" : _b;
    var uiTheme = useDataUiTheme();
    return (React.createElement(RadixDialogue, { open: open, onOpenChange: onOpenChange, overlayClassName: "radix-flyout-overlay", contentClassName: "radix-flyout-content", useGeneratedDescriptionId: Boolean(description) },
        React.createElement("div", { className: "radix-flyout-frame", "data-ui-theme": uiTheme },
            React.createElement("header", { className: "radix-flyout-header" },
                React.createElement(Dialog.Title, { className: "radix-flyout-title" }, title),
                React.createElement(Dialog.Close, { className: "radix-flyout-close", "aria-label": closeLabel },
                    React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))),
            description ? React.createElement(Dialog.Description, { className: "radix-flyout-description m-1" },
                React.createElement("span", null, description)) : null,
            React.createElement("div", { className: "radix-flyout-body" }, children))));
};
